import React, { useState, useRef, useEffect } from "react";

import api from "../../helpers/api.js";

import * as Material from "@mui/material";

import { useCommunity } from "contexts/community";

import { Button, Input } from "@fragments";

import CustomModal from "../CustomModal";

import DeleteIcon from "@mui/icons-material/Delete";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { ReactComponent as PostCreation } from "../../assets/draws/product-creation.svg";

import { UserAvatar } from '@components/Community/index.js'

import { HeartFilled, HeartOutlined, MessageFilled, MessageOutlined, SendFilled, SendOutlined } from "@components/Icons";

import "./styles.scss";
import { AddCircleRounded } from "@mui/icons-material";


const Feed = ({
  fitContentHeight = false,
  filterByUser = {},
  groupId,
  containerProps = {},
  fluidMode = false,
}) => {
  const [loadingFeed, setLoadingFeed] = useState(true);

  const [posts, setPosts] = useState([]);

  const [postOptions, setPostOptions] = useState(null);

  const { loading, community } = useCommunity();

  const isInSpecificUserMode = !!filterByUser?.id;
  const firstName = isInSpecificUserMode
    ? filterByUser.username?.split(" ")[0]
    : null;

  useEffect(() => {
    if (loadingFeed) loadFeed();
  }, [loadingFeed, filterByUser]);

  async function loadFeed() {
    setLoadingFeed(true);

    try {
      const searchString = isInSpecificUserMode
        ? "?user_id=" + filterByUser.id
        : "?group_id=" + groupId;

      const { data } = await api.get("community/post" + searchString);

      if (data && data?.length) {
        setPosts([...data]);
      }
    } catch (e) {
      window.setSnackbar("Houve um erro ao carregar o feed");
    }

    setLoadingFeed(false);
  }

  function handlePostOptionOpenFor(element, post) {
    console.log(element, post);
    const options = { element: element.currentTarget, post };
    setPostOptions({ ...options });
  }

  const Post = ({ info }) => {
    const { publisher_data, post_data } = info;

    const comm = community.get(info.community.id);
    return (
      <div className="post mb-4">
        <div className="post-header">
          <img src={publisher_data?.avatar} className="avatar" />
          <div style={{ flexGrow: 1 }}>
            <h5 className="post-publisher">{publisher_data?.username}</h5>
            <small style={{ opacity: 0.7 }} className="csf-2">
              {window.helpers.pretty.date(post_data.published_at)}
            </small>
          </div>
          {publisher_data?.points_earned > 0 && (
            <small className="points-earned">
              +{publisher_data?.points_earned} pts
            </small>
          )}
          {comm.isAdmin() && (
            <Material.IconButton
              id={"open-options-btn-" + info.id}
              onClick={(e) => handlePostOptionOpenFor(e, info)}
            >
              <MoreVertIcon fontSize="small" />
            </Material.IconButton>
          )}
        </div>
        <div className="post-content mt-1">
          <span>{post_data.text}</span>
          {post_data.photo && (
            <PostImage src={post_data.photo} />
          )}
          <ReactionsBar
            postId={info.id}
            comments={post_data.comments}
            post={info}
          />
        </div>
      </div>
    );
  };

  function ReactionsBar({ post, postId, comments = [] }) {
    function getReactions() {
      const { reactions, commentsTotal } = post?.post_data || {}

      return {
        love: {
          total: reactions?.heart?.total || 0,
          reacted: reactions?.heart?.reacted || false,
        },
        comment: {
          total: commentsTotal || 0,
        },
      }
    }

    const [reactions, setReactions] = useState(getReactions())


    async function handleReact(type, reaction, subreaction_of_id) {
      if (type === 'COMMENT' && (reaction.length < 1 || reaction.length > 250)) {
        return
      }

      const payload = {};

      if (type === "COMMENT") payload.text = reaction;
      else if (type === "REACTION") payload.reaction = reaction;
      else {
        payload.reaction = "heart";
        type = "REACTION";
      }

      try {
        const result = await api.post("community/post/react", {
          post_id: postId,
          type: type,
          payload: payload,
          subreaction_of_id,
        });


        if (result?.data?.gamification)
          console.log(result.data.gamification);

        return !!result?.data?.success;
      } catch (e) {
        console.log("Reaction error", e);
      }

      return false;
    }
    function NewComment() {
      const [comment, setComment] = useState("");
      const [loading, setLoading] = useState(false)

      const maxLength = 250;
      const oversized = comment.length > maxLength

      async function handlePublish() {
        setLoading(true)
        await handlers.comment(comment);
        setComment('')
        setLoading(false)
      }

      return (
        <div className="new-comment-box">
          <div className="new-comment-input-box">
            <Input.Text
              emojiPreview={true}
              emoji
              disabled={loading}
              className={`add-new-comment-input ${oversized ? 'error-mode' : ''}`}
              multiline
              value={comment}
              variant="standard"
              onInput={(e) => setComment(e)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey && comment.length > 2 && !oversized) {
                  e.preventDefault();
                  handlePublish()
                }
              }}
              placeholder="Adicione um comentário"
              error={oversized}
            />
            {
              comment.length > 50 && <div className="character-counter">
                <span className={oversized ? 'error-text' : ''}>
                  {comment.length}/{maxLength}
                </span>
              </div>
            }
          </div>
          {
            comment.length > 2 && !oversized && <Button
              disabled={loading}
              className="publish-comment-btn"
              variant="contained"
              onClick={handlePublish}
            >
              Publicar
            </Button>
          }
        </div>
      )
    }

    function Reaction({ icon, amount, onClick, style = {} }) {
      return (
        <div className="reaction-box csf-5 px-1 py-1" style={{ ...style }} onClick={onClick}>
          {React.cloneElement(icon, { color: "currentColor" })}
          {
            amount > 0 && <span style={{ color: "currentColor" }}>
              {amount}
            </span>
          }
        </div>
      )
    }


    const handlers = {
      love: () => {
        console.log(reactions)

        setReactions({
          ...reactions,
          heart: {
            reacted: !reactions?.heart?.reacted,
            total: (reactions?.heart?.total || 0) + (reactions?.heart?.reacted ? -1 : 1)
          }
        })
      },
      comment: async (comment) => {
        try {
          await handleReact("COMMENT", comment);
          setReactions({
            ...reactions,
            comment: {
              reacted: true,
              total: (reactions?.comment?.total || 0) + 1
            }
          })
          window.setSnackbar("Comentário publicado com sucesso")
        } catch (e) {
          console.log(e)
        }
      }
    }


    return (
      <>
        <div className="footer-actions mt-1" >
          <div className="reactions-bar csf-5">
            <Reaction
              icon={reactions?.heart?.reacted ? <HeartFilled style={{ color: 'currentColor' }} /> : <HeartOutlined />}
              amount={reactions?.heart?.total || 0}
              active={reactions?.heart?.reacted}
              onClick={handlers.love}
              style={{
                color: reactions?.heart?.reacted ? 'var(--error)' : 'currentColor',
                backgroundColor: reactions?.heart?.reacted ? 'var(--error-bg)' : 'transparent',
              }}
            />
            <Reaction
              icon={<MessageFilled />}
              amount={reactions?.comment?.total || 0}
              active={reactions?.comment?.reacted}
              style={{
                color: reactions?.comment?.reacted ? 'var(--primary-6)' : 'currentColor',
                backgroundColor: reactions?.comment?.reacted ? 'var(--primary-bg)' : 'transparent',
              }}
            />
            <Reaction
              icon={<SendFilled />}
              amount={post?.post_data.sharesTotal}
              onClick={() => handleReact("SHARE", "share")}
            />
          </div>

          <NewComment />
        </div >

      </>
    )
  }

  const Comments = ({ comments, postId, total }) => {
    function Comment({ info }) {
      return (
        <div className="mt-1">
          <UserAvatar
            user={{
              id: info.user_id,
              username: info.username,
              avatar: info.avatar
            }}
            size={19}
            className="mb-1"
            displayName={true}
            displayNickname={true}
          />
          <small style={{ opacity: 0.65 }}>{info.payload?.text || info.text}</small>
        </div>
      )
    }
    return (
      <div className="mt-2">
        {
          comments?.slice(0, 3).map((comment, i) => {
            return <Comment
              key={'comment-' + postId + '-' + i}
              info={comment}
              postId={postId}
            />
          })
        }
        {
          total > 3 && <div className="pt-2">
            <small >+ {total - 3} comentários</small>
          </div>
        }
      </div>
    )
  }


  const NoPostsFound = () => {
    return (
      <div className="no-posts-found mt-3" {...containerProps}>
        <PostCreation className="no-posts-banner" />
        <h4 className="mb-1 mt-1">
          {isInSpecificUserMode
            ? firstName + " ainda não postou em uma comunidade"
            : "Nenhum post foi publicado neste grupo ainda"}
        </h4>
        <span>
          Compartilhe o link de convite com sua audiência e os incentive a
          interagir na sua comunidade
        </span>
      </div>
    );
  };

  const LoadingComponents = () => {
    return (
      <div className="loading-feed-container px-8">
        <Material.Skeleton height={80} className="mt-2" />

        <Material.Skeleton height={300} className="mt-2" />

        <Material.Skeleton height={300} className="mt-2" />
      </div>
    );
  };

  const PostOptionsModal = () => {
    if (!postOptions?.post) return;

    const { publisher_data: publisher, id: postId } = postOptions.post;

    async function handleOpenDeletePost() {
      window.openConfirm({
        title: "Apagar post",
        headline: "Atenção!",
        subtitle: "Você realmente deseja apagar permanentemente este post?",
        buttons: [
          {
            text: "Apagar permanentemente",
            onClick: handleExecuteDelete,
            variant: "contained",
            className: "",
            color: "error",
          },
          {
            text: "Manter post",
            variant: "text",
          },
        ],
      });

      async function handleExecuteDelete() {
        try {
          const { data } = await api.delete("/community/post?id=" + postId);

          if (data.success) {
            window.setSnackbar("Post deletado com sucesso");
            setPostOptions(null);
            setLoadingFeed(true);
          } else {
            window.setSnackbar(
              "Houve um erro ao apagar este post, tente novamente em alguns minutos"
            );
          }
        } catch (e) {
          window.setSnackbar(
            "Houve um erro ao apagar este post, tente novamente mais tarde"
          );
        }
      }
    }

    async function handleOpenDeducePostPoints() {
      window.openConfirm({
        title: "Deduzir pontos",
        headline: "Atenção!",
        subtitle: "Você realmente deseja zerar os pontos deste post?",
        buttons: [
          {
            text: "Zerar pontuação do post",
            onClick: handleExecuteDeduction,
            variant: "contained",
            className: "",
            color: "error",
          },
          {
            text: "Manter post",
            variant: "text",
          },
        ],
      });

      async function handleExecuteDeduction() {
        try {
          const { data } = await api.delete(
            "/community/post/points?id=" + postId
          );

          if (data.success) {
            window.setSnackbar("Pontos removidos com sucesso");
            setPostOptions(null);
            setLoadingFeed(true);
          } else {
            window.setSnackbar(
              "Houve um erro ao deduzir os pontos deste post, tente novamente em alguns minutos"
            );
          }
        } catch (e) {
          window.setSnackbar(
            "Houve um erro ao deduzir os pondos deste post, tente novamente mais tarde"
          );
        }
      }
    }

    function AddPointsButton() {
      const [points, setPoints] = useState(10)
      const [open, setOpen] = useState(false)
      const [loading, setLoading] = useState(false)

      async function handleAddPoints() {
        if (points <= 0 || points > 50000) {
          window.setSnackbar('Adicione uma quantidade de pontos entre 1 e 50000')
          return
        }

        setLoading(true)
        try {
          const { data } = await api.post(
            "/community/post/points",
            {
              id: postId,
              points
            }
          );

          if (data.success) {
            window.setSnackbar("Pontos adicionados com sucesso");
            setOpen(false);
            setPostOptions(null);
            setLoadingFeed(true);
          } else {
            window.setSnackbar(
              "Houve um erro ao adicionar os pontos deste post, tente novamente em alguns minutos"
            );
          }
        } catch (e) {
          window.setSnackbar(
            "Houve um erro ao adicionar os pondos deste post, tente novamente mais tarde"
          );
        }
        setLoading(false)
      }

      return (
        <div className="">
          <Material.Button
            className="list-button"
            variant="text"
            onClick={() => setOpen(true)}
            startIcon={<AddCircleRounded />}
          >
            Adicionar pontos
          </Material.Button>
          {
            open && <div className="add-points-to-post-input mt-1 mb-2">
              <Input.Integer
                disabled={loading}
                value={points}
                onInput={setPoints}
                min={1}
                max={100}
                label="Pontos a adicionar"
              />
              <Material.Button disabled={loading} variant="contained" onClick={handleAddPoints} className="add-points-btn">
                Adicionar
              </Material.Button>

            </div>
          }
        </div>
      )
    }

    return (
      <CustomModal
        maxWidth={400}
        bottomButtonCancelText="Cancelar"
        hideSecondaryButton={false}
        loading={false}
        title="Opções do post"
        handleSubmit={() => { }}
        open={!!postOptions?.post}
        handleClose={() => setPostOptions(null)}
        width="100%"
        bodyWrapperStyle={{}}
        bodyComponent={
          <div className="container px-3 pt-3">
            <AddPointsButton />
            <Material.Button
              className="list-button"
              variant="text"
              color="secondary"
              onClick={handleOpenDeducePostPoints}
              disabled={!publisher.points_earned}
              startIcon={<RemoveCircleIcon />}
            >
              Deduzir pontos ({publisher.points_earned || 0} pts)
            </Material.Button>
            <Material.Divider />
            <Material.Button
              className="list-button"
              variant="text"
              color="error"
              startIcon={<DeleteIcon color="error" />}
              onClick={handleOpenDeletePost}
            >
              Apagar post
            </Material.Button>
          </div>
        }
      />
    );
  };

  return (
    <div
      className={
        "feed-area " +
        (fitContentHeight && "fluid-feed-height") +
        (fluidMode && " fluid-mode")
      }
    >
      <PostOptionsModal />
      <div className="feed-container">
        {loading || loadingFeed ? (
          <LoadingComponents />
        ) : (
          <>
            {posts?.length > 0 ? (
              posts.map((post, i) => {
                return (
                  <>
                    {i !== 0 && <Material.Divider className="posts-divider mb-4" />}
                    {post?.publisher_data && <div className="screen-padding">
                      <Post key={i} info={post} />
                    </div>}

                  </>
                );
              })
            ) : (
              <NoPostsFound />
            )}
          </>
        )}

        <div style={{ height: "80px" }}></div>
      </div>
    </div>
  );
};

export default Feed;


function PostImage({ src }) {
  return (
    <div className="media-container">
      <img src={src} className="photo" />
      <img src={src} className="photo-bg" />
    </div>
  )
}
